// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import InstallmentPrepareController from "./installment_prepare_controller"
application.register("installment-prepare", InstallmentPrepareController)


import InstallmentFinalController from "./installment_final_controller"
application.register("installment-final", InstallmentFinalController)